import type { ParticipantView } from "../../shared/types.ts";
import { RichText } from "./ParticipantFields.tsx";
import "./participant-fidelity.css";

/** Only the server's accepted chapter context reaches this view. */
export function ParticipantHistory({
  entries,
}: {
  entries: NonNullable<ParticipantView["history"]>;
}) {
  return (
    <section className="pe-history" aria-label="Earlier in this conversation">
      <p className="pe-history__label">Earlier in this conversation</p>
      <ol>
        {entries.map((entry) => (
          <li key={entry.stepId} data-history-step={entry.stepId}>
            <p className="pe-history__prompt">
              <RichText text={entry.prompt} />
            </p>
            <p className="pe-history__answer">
              <span className="pe-sr">Your answer: </span>
              <RichText text={entry.answer} />
            </p>
            {entry.reflection && (
              <p className="pe-history__reflection">
                <span className="pe-sr">Reflection: </span>
                <RichText text={entry.reflection} />
              </p>
            )}
          </li>
        ))}
      </ol>
    </section>
  );
}
